'use client'
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import bs58 from 'bs58';
import { TransactionGasCannotBeSponsoredError } from '@dynamic-labs/utils';
import { isAccountAbstractionConnector } from '@dynamic-labs/wallet-connector-core';
import '../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/sdk-api-core';
import { logger } from '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../utils/constants/colors.js';
import '../../utils/constants/values.js';
import { useEffectOnce } from '../../shared/utils/hooks/useEffectOnce/useEffectOnce.js';
import '../../store/state/loadingAndLifecycle.js';
import '../../shared/consts/index.js';
import '../../events/dynamicEvents.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
import '../../config/ApiEndpoint.js';
import '../../store/state/user/user.js';
import '../../locale/locale.js';
import '../../store/state/projectSettings/projectSettings.js';
import '../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../context/AccountExistsContext/AccountExistsContext.js';
import '../../context/UserWalletsContext/UserWalletsContext.js';
import '../../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import '../../context/WalletContext/WalletContext.js';
import '../../utils/hooks/useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import { usePromise } from '../../utils/hooks/usePromise/usePromise.js';
import '../../context/ThemeContext/ThemeContext.js';
import { useForceUpdate } from '../../utils/hooks/useForceUpdate/useForceUpdate.js';
import { useInterval } from '../../utils/hooks/useInterval/useInterval.js';
import '../../utils/hooks/useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import { useMutation } from '../../utils/hooks/useMutation/useMutation.js';
import '@dynamic-labs/types';
import '../../context/LoadingContext/LoadingContext.js';
import 'yup';
import '../../context/MockContext/MockContext.js';
import '../CollectUserDataView/useFields.js';
import '../../context/FieldsStateContext/FieldsStateContext.js';
import '../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../../store/state/environmentId.js';
import '../../store/state/walletConnectorOptions.js';
import '../../components/Accordion/components/AccordionItem/AccordionItem.js';
import { Alert } from '../../components/Alert/Alert.js';
import { Typography } from '../../components/Typography/Typography.js';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../components/IconButton/IconButton.js';
import '../../components/InlineWidget/InlineWidget.js';
import '../../components/Input/Input.js';
import '../../components/IsBrowser/IsBrowser.js';
import '../../components/MenuList/Dropdown/Dropdown.js';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../components/OverlayCard/OverlayCardTarget/OverlayCardTarget.js';
import '../../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../../components/Popper/Popper/Popper.js';
import '../../components/Popper/PopperContext/PopperContext.js';
import 'react-focus-lock';
import 'qrcode';
import { useFetchCurrency } from '../../widgets/DynamicWidget/hooks/useFetchCurrency/useFetchCurrency.js';
import 'formik';
import '../../context/FooterAnimationContext/index.js';
import '../../context/WalletGroupContext/WalletGroupContext.js';
import '../../context/IpConfigurationContext/IpConfigurationContext.js';
import '../../context/SocialRedirectContext/SocialRedirectContext.js';
import '../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '@hcaptcha/react-hcaptcha';
import '../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../context/PasskeyContext/PasskeyContext.js';
import '../../store/state/sendBalances.js';
import { TransactionConfirmationPageLayout } from '../../components/TransactionConfirmationPageLayout/TransactionConfirmationPageLayout.js';
import '../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import { simulateBlockaidSVMTransaction, simulateBlockaidEVMTransaction } from '../../data/api/transactions/blockaid.js';
import { useTransactionTotal } from './hooks/useTransactionTotal/useTransactionTotal.js';
import { transactionErrorMessage } from './helpers/transactionErrorMessage.js';
import '../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import '../../../index.js';
import '../../store/state/tokenBalances.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useDynamicContext/useInternalDynamicContext.js';

const FEE_REFRESH_INTERVAL = 20000;
const TransactionConfirmationView = ({ transaction, onError, onSuccess, mutation, onClickBack, walletConnector, onClickClose, title, displayPoweredByDynamicFooter = false, copykey, hideModal, currentToken, isNativeToken, transactionValue, isModal, sendBalanceTransaction, }) => {
    var _a, _b;
    const { primaryWallet, environmentId } = useInternalDynamicContext();
    const [isGasSponsored, setIsGasSponsored] = useState(false);
    const update = useForceUpdate();
    const { t } = useTranslation();
    const { currency } = useFetchCurrency(walletConnector);
    // Update the chainId access to handle undefined case
    const chainId = useMemo(() => {
        if (!(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector)) {
            return undefined;
        }
        const connector = primaryWallet.connector;
        return connector._selectedChainId || connector.lastUsedChainId;
    }, [primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector]);
    const [simulationResult, setSimulationResult] = useState(undefined);
    const [isSimulationComplete, setIsSimulationComplete] = useState(false);
    useEffectOnce(() => {
        const fetchSimulationResult = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (sendBalanceTransaction) {
                setIsSimulationComplete(true);
                return;
            }
            // Skip simulation if chainId is not available
            if (!chainId && (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain) !== 'SOL') {
                setIsSimulationComplete(true);
                return;
            }
            let result;
            try {
                // SOLANA
                if (!chainId) {
                    const encodedTransactions = (_a = transaction.multipleTransactions) === null || _a === void 0 ? void 0 : _a.map((tx) => bs58.encode(tx.serialize({ requireAllSignatures: false })));
                    if (!encodedTransactions) {
                        setIsSimulationComplete(true);
                        return;
                    }
                    result = yield simulateBlockaidSVMTransaction({
                        accountAddress: transaction.from,
                        chain: (yield (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.getNetwork())),
                        environmentId,
                        transactions: encodedTransactions,
                    });
                }
                else {
                    // EVM
                    result = yield simulateBlockaidEVMTransaction({
                        chainId: String(chainId),
                        data: transaction.data || '0x',
                        environmentId,
                        from: transaction.from,
                        to: transaction.to || '',
                        value: ((_b = transaction.value) === null || _b === void 0 ? void 0 : _b.toString()) || '0',
                    });
                }
            }
            catch (error) {
                setSimulationResult(undefined);
            }
            setSimulationResult(result);
            setIsSimulationComplete(true);
        });
        fetchSimulationResult();
    });
    /**
     * Update transaction fee and trigger a react update
     * to reflect the new fee on the UI
     */
    const fetchTransactionFee = () => {
        // solana fee doesnt need to be refreshed
        if ((primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain) === 'SOL' && transaction.fee.gas !== undefined)
            return;
        transaction.fetchFee().finally(update);
    };
    const { isLoading: isGasSponsoredLoading } = usePromise(() => {
        if (!isAccountAbstractionConnector(walletConnector)) {
            return false;
        }
        return walletConnector.canSponsorTransactionGas(transaction);
    }, {
        initialData: false,
        onReject: logger.error,
        onResolve: (isGasSponsored) => {
            setIsGasSponsored(isGasSponsored);
            if (!isGasSponsored && isAccountAbstractionConnector(walletConnector)) {
                walletConnector.disableGasSponsorshipOnce();
            }
        },
    });
    // solana gas sponsorship check
    if ((_a = transaction.isGasSponsored) === null || _a === void 0 ? void 0 : _a.call(transaction)) {
        setIsGasSponsored(true);
    }
    const { mutate: send, isLoading, error: transactionError, } = useMutation(mutation, {
        onFailure: (error) => {
            fetchTransactionFee();
            if (TransactionGasCannotBeSponsoredError.isInstance(error)) {
                logger.debug(error);
                setIsGasSponsored(false);
                if (isAccountAbstractionConnector(walletConnector)) {
                    walletConnector.disableGasSponsorshipOnce();
                }
            }
            logger.error(error);
            onError === null || onError === void 0 ? void 0 : onError(error);
        },
        onSuccess: (tx) => onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(tx),
    });
    // Refresh transaction fee, Solana fees are static based on transaction data, dont need to refresh them
    useInterval(fetchTransactionFee, isLoading ? null : FEE_REFRESH_INTERVAL);
    useEffectOnce(fetchTransactionFee);
    const total = useTransactionTotal({
        gasTotalPrice: transaction.fee.gas,
        isGasSponsored,
        transactionValue: transaction.value,
    });
    const errorMessage = transactionError && transactionErrorMessage(transactionError);
    const { data: balance, isLoading: isBalanceLoading } = usePromise(() => transaction.getBalance());
    const hasInsufficientFunds = useMemo(() => {
        if (!total || !balance)
            return false;
        return balance < total;
    }, [balance, total]);
    const missingFunds = useMemo(() => {
        if (!total || !balance)
            return undefined;
        return total - balance;
    }, [total, balance]);
    const alert = useMemo(() => {
        if (errorMessage)
            return null;
        if (TransactionGasCannotBeSponsoredError.isInstance(transactionError)) {
            return (jsx(Alert, { icon: 'error', variant: 'error', copykey: 'dyn_send_transaction.error_message.gas_not_sponsored', children: t('dyn_send_transaction.error_message.gas_not_sponsored') }));
        }
        if (!isGasSponsoredLoading &&
            !isBalanceLoading &&
            missingFunds === undefined &&
            transaction.fee.gas &&
            !isGasSponsored) {
            return (jsxs(Alert, { icon: 'error', variant: 'error', contentDataTestId: 'warning_content', copykey: 'dyn_send_transaction.warning_message.insufficient_gas_funds', children: [jsx(Typography, { variant: 'body_normal', color: 'primary', children: t('dyn_send_transaction.warning_message.insufficient_gas_funds.title') }), jsx(Typography, { variant: 'body_normal', color: 'secondary', children: t('dyn_send_transaction.warning_message.insufficient_gas_funds.description', {
                            amountLeft: transaction.format(transaction.fee.gas, {
                                precision: 6,
                            }),
                            currencySymbol: currency,
                        }) })] }));
        }
        if (transaction.simulationFailed) {
            return (jsxs(Alert, { icon: 'error', variant: 'warning', contentDataTestId: 'warning_content', copykey: 'dyn_send_transaction.warning_message.failed_simulation', children: [jsx(Typography, { variant: 'body_normal', color: 'primary', children: t('dyn_send_transaction.warning_message.failed_simulation.title') }), jsx(Typography, { variant: 'body_normal', color: 'secondary', children: t('dyn_send_transaction.warning_message.failed_simulation.description') })] }));
        }
        const showInsufficientFundsWarningMessage = hasInsufficientFunds && missingFunds;
        if (!showInsufficientFundsWarningMessage)
            return;
        const amountLeft = transaction.format(missingFunds, { precision: 5 });
        return (jsxs(Alert, { icon: 'error', variant: 'warning', contentDataTestId: 'warning_content', copykey: 'dyn_send_transaction.warning_message.insufficient_funds', children: [jsx(Typography, { variant: 'body_normal', color: 'primary', children: t('dyn_send_transaction.warning_message.insufficient_funds.title') }), jsx(Typography, { variant: 'body_normal', color: 'secondary', children: t('dyn_send_transaction.warning_message.insufficient_funds.description', {
                        amountLeft,
                        currencySymbol: currency,
                    }) })] }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        transaction,
        errorMessage,
        transactionError,
        hasInsufficientFunds,
        missingFunds,
        t,
        currency,
        transaction.fee.gas,
        isLoading,
        simulationResult,
    ]);
    if (!isSimulationComplete) {
        return null;
    }
    // if simulation threw an error, or if there are no out assets for solana (which means the simulation failed)
    if ((!simulationResult ||
        (!simulationResult.outAssets.length &&
            !chainId &&
            !((_b = transaction.isGasSponsored) === null || _b === void 0 ? void 0 : _b.call(transaction)))) &&
        !sendBalanceTransaction) {
        transaction.simulationFailed = true;
    }
    return (jsx(TransactionConfirmationPageLayout, { total: total, currentToken: currentToken, transactionValue: transactionValue, isNativeToken: isNativeToken, onClickBack: onClickBack, onClickClose: onClickClose, copykey: copykey, title: title, hideModal: hideModal, isLoading: isLoading, onClickSend: () => send(), onSuccess: (tx) => onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(tx), displayPoweredByDynamicFooter: displayPoweredByDynamicFooter, disableSendButton: isBalanceLoading, error: errorMessage, alert: alert, walletConnector: walletConnector, transaction: transaction, isGasSponsored: isGasSponsored, isGasSponsoredLoading: isGasSponsoredLoading, walletKey: (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.key) || '', simulationResult: simulationResult, sendBalanceTransaction: sendBalanceTransaction }));
};

export { FEE_REFRESH_INTERVAL, TransactionConfirmationView };
